/**
 * Max lines to asynchronously sync code to the Lines instance at once.
 *
 * @since 0.1.0
 */
export const ASYNC_SYNC_LINES = 3000;

/**
 * Max lines to scan up for asynchronously sync.
 *
 * @since 0.1.0
 */
export const ASYNC_SYNC_LINES_BACKWARDS = 100;

/**
 * Max lines to scan up for synchronously sync.
 *
 * @since 0.1.0
 */
export const SYNC_LINES_BACKWARDS = 100;
